/** Donation journey path roots — canonical `/:tenantCode/donate/*` per ADR-012. */

export interface DonationRoutePaths {
  readonly embeddedInAccount: boolean;
  readonly donatePath: string;
  readonly projectsPath: string;
}

export function isAccountEmbeddedDonationPath(pathname: string): boolean {
  return pathname.includes('/account/donate');
}

export function resolveDonationRoutePaths(
  tenantCode: string,
  pathname: string,
): DonationRoutePaths {
  const embeddedInAccount = isAccountEmbeddedDonationPath(pathname);
  const donatePath = `/${encodeURIComponent(tenantCode)}/donate`;
  return {
    embeddedInAccount,
    donatePath,
    projectsPath: `${donatePath}/projects`,
  };
}

/** Map legacy `/account/donate…` to canonical `/donate…`. */
export function mapDonatePathToAccountDonate(
  tenantCode: string,
  pathname: string,
  search: string,
): string {
  const prefix = `/${encodeURIComponent(tenantCode)}`;
  const rel = pathname.startsWith(prefix) ? pathname.slice(prefix.length) : pathname;
  const donateSuffix = rel.replace(/^\/account\/donate/, '').replace(/^\/donate/, '');
  return `${prefix}/donate${donateSuffix}${search}`;
}
